<template>
  <div class="">
    <div class="card card-with-search border-0 card-with-shadow">
      <div class="text-justify">
        <app-tab :tabs="tabsHorizontal" type="horizontal" />
      </div>
    </div>
  </div>
</template>
<script>
import CopyButton from "../../../../Demo/UI/CopyButton.vue";

export default {
  name: "Tabs",
  components: { CopyButton },
  data() {
    return {
      icon: "settings",
      isAddEditModalActive: false,
      tabsHorizontal: [
        {
          icon: "message-square",
          name: "Review",
          component: "job-review-review",
          permission: "",
        },
        {
          icon: "award",
          name: "Feedback",
          component: "job-review-feedback",
          permission: "",
        },
      ],
    };
  },
  methods: {
  },
  computed: {
    userList() {
      return this.$store.state.user.loggedInUser;
    },
  },
};
</script>
